export default "<div class=\"logo\">\n</div>\n"